<template>
    <div>
      <b-modal
      id="modal-xl"
      ref="my-modal"
      no-close-on-backdrop
      ok-title="Close"
      @hidden="close()"
      scrollable
      centered
      modal-header
      button-size="sm"
      size="xl"
      title="Invoice Review"
    >
     <embed :src="iframe_src" width="100%" height="600px" type="application/pdf">
      <template #modal-footer="{ ok , closeModal  }">
      <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
      </b-button>
    </template>
      </b-modal>
      <b-row>
        <b-col
          cols="12"
          md="2"
          class="align-items-center justify-content-start mb-1 mb-md-0"
        >
  
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="align-items-center justify-content-start mb-1 mb-md-0"
        >
      </b-col>
      <b-col
          cols="12"
          md="3"
          class="align-items-center justify-content-start mb-1 mb-md-0"
        >
        <v-select
                v-model="teacher_id"
                label="label"
                :clearable="false"
                :options="teachers"
                :reduce="user => user.value"
                class="mb-1 mr-1"
                v-if="$can('read', 'manager')" 
                />
      </b-col>
        <b-col
          cols="12"
          md="4"
        >    
          <div class="d-flex align-items-center justify-content-end">           
            <flat-pickr
            v-model="rangeDate"
            class="form-control mb-1 mr-1"
            :config="{ mode: 'single',dateFormat: 'Y-m'}"
          />
            <b-button
              variant="primary"
              class="mb-1"
              @click="exportToExcel()"
            >
              <span class="text-nowrap">Export</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
            <b-card>
                <div class="text-center"><h3>新生</h3></div>
                <b-row>
                    <b-col class="text-center">
                        <b-avatar
                            size="70px"
                            variant="light-danger" 
                            text="3"
                            /><br> <span v-if="stats != null && stats.new && stats.new.s3"><b class="font15">{{ stats.new.s3.count }} </b></span><br />
                            <b-badge v-if="stats != null && stats.new && stats.new.s3">$ {{  stats.new.s3.amount }}</b-badge>
                    </b-col>
                    <b-col class="text-center">
                        <b-avatar
                            size="70px"
                            variant="light-info"
                            text="6"
                            /><br><span v-if="stats != null && stats.new && stats.new.s6"><b class="font15">{{ stats.new.s6.count }}</b> </span><br />
                            <b-badge v-if="stats != null && stats.new && stats.new.s6 != null">$ {{  stats.new.s6.amount }}</b-badge>
                    </b-col>
                    <b-col class="text-center">
                        <b-avatar
                            size="70px"
                            variant="light-success"
                            text="12"
                            /><br><span v-if="stats != null && stats.new && stats.new.s12"><b class="font15">{{ stats.new.s12.count }}</b> </span><br />
                            <b-badge v-if="stats != null && stats.new && stats.new.s12 != null">$ {{  stats.new.s12.amount }}</b-badge>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col class="text-center"><hr /><span style="font-size:20px;font-weight: bold;" v-if="stats != null &&  stats.new != null">$ {{ stats.new.amount}} </span></b-col>
                </b-row>
            </b-card>
        </b-col>
        <b-col>
            <b-card>
                <div class="text-center"><h3>舊生</h3></div>
                <b-row>
                    <b-col class="text-center">
                        <b-avatar
                            size="70px"
                            variant="light-danger"
                            text="3"
                            /><br> <span v-if="stats != null && stats.old && stats.old.s3"><b class="font15">{{ stats.old.s3.count }} </b></span><br />
                            <b-badge v-if="stats != null && stats.old && stats.old.s3">$ {{  stats.old.s3.amount }}</b-badge>
                    </b-col>
                    <b-col class="text-center">
                        <b-avatar
                            size="70px"
                            variant="light-info"
                            text="6"
                            /><br><span v-if="stats != null && stats.old && stats.old.s6"><b class="font15">{{ stats.old.s6.count }}</b> </span><br />
                            <b-badge v-if="stats != null && stats.old && stats.old.s6 != null">$ {{  stats.old.s6.amount }}</b-badge>
                    </b-col>
                    <b-col class="text-center">
                        <b-avatar
                            size="70px"
                            variant="light-success"
                            text="12"
                            /><br><span v-if="stats != null && stats.old && stats.old.s12"><b class="font15">{{ stats.old.s12.count }}</b> </span><br />
                            <b-badge v-if="stats != null && stats.old &&  stats.old.s12 != null">$ {{  stats.old.s12.amount }}</b-badge>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col class="text-center"><hr /><span style="font-size:20px;font-weight: bold;" v-if="stats != null &&  stats.old != null">$ {{ stats.old.amount}} </span></b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
      <!-- table -->
      <b-card>
      <b-table
      ref="selectableTable"
      selectable
      select-mode="single"
      :items="items"
      :fields="fields"
      responsive
      striped
      class="mb-0"
      @row-selected="onRowSelected"
      >
        <template #cell(status_number)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
        <template #cell()="data">
            <span v-if="data.value != '0' && data.value != '1'">{{ data.value }}</span>
            <span v-if="data.value <= 1" style="color:#ddd;">{{ data.value }}</span>
        </template>
        <template #cell(attend)="data">
          <b-badge variant="primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(amount)="data">
          <span v-if="data.item.status == 'VOID'" style="color:red;"><b> -{{data.item.amount}}</b></span>
          <span v-if="data.item.status == 'ACTIVE'">{{data.item.amount}}</span>
        </template>
      </b-table>
    </b-card>
    </div>
  </template>
  
  <script>
  import BCardCode from '@core/components/b-card-code/BCardCode.vue'
  
  import vSelect from 'vue-select'
  import Ripple from 'vue-ripple-directive'
  import flatPickr from 'vue-flatpickr-component'
  import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
  import moment from 'moment'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import {
    BTable, BAvatar, BCard, BCardBody, BBadge,  BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend,BModal, VBModal} from 'bootstrap-vue'
  export default {
    components: {
      moment,
      flatPickr,
      BCard,
      StatisticCardHorizontal,
      BTable,
      ToastificationContent,
      BModal, VBModal,
      BAvatar,
      BBadge,
      BRow,
      BCol,
      BFormGroup,
      BFormSelect,
      BPagination,
      BInputGroup,
      BFormInput,
      BInputGroupAppend,
      BInputGroupPrepend,
      BButton,
      BPagination,
      BCardCode,
      BTable,
      BButton,
      BFormGroup,
      BAvatar,
      BCardBody,
      BBadge,
      vSelect,
    },
    directives: {
      Ripple,
    },
    data() {
      return {
        iframe_src : '//rb.cloudedu.pro/invoice.php',
        rangeDate: null,
        searchString: null,
        type:'all',
        test_string : null,
        headerTitle: ['Transaction Code', 'Student Name','Grade', 'Package (Month)', 'DateTime','New Join','Amount'],
        headerVal: ['code', 'student_name', 'grade', 'lesson_paid','created_at','is_newjoiner','price'],
        teachers:[],
        centerOptions: [],
        isAddoldMemberSidebarActive: false,
        searchString: null,
        perPage: 10,
        startRow: 1,
        stats:null,
        teacher_id:JSON.parse(localStorage.getItem('userData')).id,
        endRow: 10,
        totalAmount: 0,
        pageOptions: [10, 15, 20],
        totalRows: 1,
        currentPage: 1,
        fields: [
          { key: 'code', label: 'Transaction Code' },
          { key: 'student_name', label: 'Student Name'},
          { key: 'grade', label: 'Student grade'},
          { key: 'lesson_paid', label: 'Package (Month)' },
          { key: 'created_at', label: 'Date Time' },
          { key: 'is_newjoiner', label: 'New Join'},
          { key: 'price', label: 'Amount'}
        ],
        /* eslint-disable global-require */
        items: [],
        /* eslint-disable global-require */
        status: [{
          1: 'Active', 2: 'Disabled', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
        },
        {
          1: 'light-success', 2: 'light-danger', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
        }],
        selectMode: 'single',
        selected: [],
      }
    },
    watch: {
      teacher_id: {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
      rangeDate : {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
      currentPage: {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
      perPage: {
        handler(newValue, oldValue) {
          if (newValue < 9) {
            this.perPage = 10
          }
          // console.log("search")
          this.handleSearch()
        },
      },
    },
    created() {
      this.get_staffs()
      this.get_data()
    },
    methods: {
    get_staffs() {
        this.$http.get(process.env.VUE_APP_API_BASE+'/staffs/select/',{})
          .then(res => {
            this.teachers = res.data
            
          })
      },
      send() {
        this.$http.post(process.env.VUE_APP_API_BASE+'/transaction/'+this.selected.id+'/send/',{})
          .then(res => {
            this.$refs['my-modal'].hide()
          })
      },
      exportToExcel() {
        // console.log(this.items)
        // console.log(this.headerTitle)
        import('@/@core/Export2Excel').then(excel => {
          const list = this.items
          const data = this.formatJson(this.headerVal, list)
          excel.export_json_to_excel({
            header: this.headerTitle,
            data,
            filename: 'staff_'+this.teacher_id+'_'+this.rangeDate,
            autoWidth: true,
            bookType: 'xlsx'
          })
          //this.clearFields()
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v =>
          filterVal.map(j => {
            // Add col name which needs to be translated
            // if (j === 'timestamp') {
            //   return parseTime(v[j])
            // } else {
            //   return v[j]
            // }
  
            return v[j]
          })
        )
      },
      get_data() {
        this.stats = null
        this.items = []
        if (this.rangeDate === null) {
          this.rangeDate = moment().format('YYYY-MM')
        }
        this.$http.get(process.env.VUE_APP_API_BASE+`/report/user-commission/?user_id=` + this.teacher_id +`&date=`+this.rangeDate)
          .then(res => {
            this.items = res.data.transactions
            this.stats = res.data.stats
          })
      },
      get_center_data() {
        this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
          .then(res => {
            this.centerOptions = res.data.centers
          })
      },
      handleChangePage() {
  
      //  this.get_data()
      },
      onRowSelected(items) {
        
        this.selected = items[0]
        this.iframe_src = '//rb.cloudedu.pro/pdf/INVOICE_'+items[0].code+'.pdf'
        this.transaction_id = items[0].transaction_id
        this.$refs['my-modal'].show()
      },
      close() {
        this.iframe_src = '//www.cloudfit.pro/invoice.php'
        this.$refs['my-modal'].hide()
        this.clearSelected()
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },
      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },
      selectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.selectRow(2)
      },
      unselectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.unselectRow(2)
      },
  
      handleSearch() {
        // let _print = `The user searched for: ${searching}\n`
        // this.$refs.pre.appendChild(document.createTextNode(_print))
      // this.searchString = searching
      // this.currentx = 1
      // this.get_data()
        this.searchTimeOut()
      },
      searchTimeOut() {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => {
          // your code
          this.currentPage = 1
          this.get_data(this.searchString)
        }, 500)
      },
    },
  }
  </script>
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  </style>
  <style lang="scss">
  .b-table-selectable{
    .feather{
      font-size: 1.3rem;
    }
  }
  .font15 {
    font-size:20px;
  }
  </style>
  